import React, { useEffect } from "react";

import '../../assets/js/form_main_2';

const CustomForm = (props) => {
    const customForm = props.deFormJson;

    useEffect(() => {
        if (customForm === null || customForm === undefined) {
            props.onFormSubmit('applicationComplete');
            return
        }
        try {
            var upwardJobForm = new window.UpwardFormHandler(customForm.jobForm);
            upwardJobForm.goNext = function () {
                this.currentFormIndex++;
                if (this.currentFormIndex < this.forms.length) {
                    this.render();
                } else {
                    this.currentFormIndex = 0;
                    this.submitAllData();
                    props.onFormSubmit('applicationComplete');
                }
            }
            upwardJobForm.render();
        } catch (e) {
            console.log(e);
            props.onFormSubmit('applicationComplete');
        }
        return () => {

        }
    }, []);


    return (
        <div id="deJobFormWrapper"></div>
    )

}

export default CustomForm;